import { Dialog } from "@headlessui/react";
import type { ContentLibraryProps } from "@rce-web/ui-content-library";
import type { ReactElement } from "react";

interface ContentLibraryDialogProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactElement<ContentLibraryProps>;
  unmount?: boolean;
}

export function ContentLibraryDialog({
  isOpen,
  onClose,
  children,
  unmount = false,
}: ContentLibraryDialogProps) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="relative z-50"
      unmount={unmount}
    >
      <div
        className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm"
        aria-hidden="true"
      />
      <div className="fixed inset-0 flex items-center justify-center p-[5vh_5vw]">
        <Dialog.Panel className="h-[90vh] w-[90vw] overflow-hidden rounded-xl border-2 border-solid border-white shadow-[0_2px_8px_-2px_rgba(255,255,255,1)]">
          {children}
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
